import User from './user';
export default class TeamUser {
    constructor(dto) {
        this.dto = Object.assign({}, dto);
    }
    get teamId() {
        return this.dto.team.substring('/teams/'.length);
    }
    set teamId(teamId) {
        this.dto.team = `/teams/${teamId}`;
    }
    get user() {
        return new User(this.dto.user);
    }
    set user(user) {
        this.dto.user = structuredClone(user.dto);
    }
    get userId() {
        return this.dto.user.id;
    }
    set userId(userId) {
        this.dto.user.id = userId;
    }
    get owner() {
        return this.dto.owner;
    }
    set owner(owner) {
        this.dto.owner = owner;
    }
    get admin() {
        return this.dto.admin;
    }
    set admin(admin) {
        this.dto.admin = admin;
    }
    get params() {
        const data = {
            team: this.dto.team,
            user: `/users/${this.userId}`,
            owner: this.dto.owner,
            admin: this.dto.admin,
        };
        return data;
    }
}
//# sourceMappingURL=team-user.js.map